// Constants.
import * as ConfigConstants from 'constants/ConfigConstants';
import * as StatsChartsConstants from 'constants/StatsChartsConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as PayProductsConstants from 'constants/PayProductsConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  isFetchedSpecial: false,
  chartsCategoriesData: [],
  chartsData: {},
  periodState: 0,
  chartsSpecialData: {},
};

export default function chartsData(state = initialState, action = {}) {
  switch (action.type) {
    case StatsChartsConstants.LOAD_CHARTS_DATA_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case StatsChartsConstants.LOAD_CHARTS_DATA_SUCCESS:
      const chartsData = Object.assign({}, state.chartsData, action.chartsData);
      const isFetched = action.lastIndex === true || state.isFetched === true;
      return {
        ...state,
        isFetched: isFetched,
        isFetchedSpecial: isFetched,
        isFetching: false,
        // chartsData: Object.assign({}, state.chartsData, action.chartsData),
        chartsData: chartsData,
        chartsSpecialData: chartsData,
      };
    case StatsChartsConstants.LOAD_SPECIAL_CHART_DATA_REQUEST:
      const periodState = parseInt(action.periodState, 10);
      return {
        ...state,
        isFetchedSpecial: false,
        periodState: periodState,
      };
    case StatsChartsConstants.LOAD_SPECIAL_CHART_DATA_SUCCESS:
      const actualChartsSpecialData = action.chartsSpecialData;
      const chartsSpecialData = Object.assign({}, state.chartsSpecialData);
      Object.keys(actualChartsSpecialData).map((key) => {
        chartsSpecialData[key] = actualChartsSpecialData[key];
      });
      return {
        ...state,
        isFetchedSpecial: true,
        // isFetching: false,
        // chartsData: Object.assign({}, state.chartsData, action.chartsData),
        // chartsData: chartsData,
        // periodState: periodState,
        chartsSpecialData: chartsSpecialData,
      };
    case ConfigConstants.LOAD_CONFIG_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        chartsCategoriesData: [],
        chartsData: {},
      };
    case PayProductsConstants.PAY_PRODUCT_SUCCESS:
    case AuthConstants.LOGIN_SUCCESS:
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        chartsCategoriesData: [],
        chartsData: {},
      };
    default:
      return state;
  }
}
